module.exports = __webpack_public_path__ + "static/media/digitalizaimg.49b12b88.png";